module.exports = __webpack_public_path__ + "images/122_640.jpg";